// src/components/background-canvas/index.js
import { connect } from 'react-redux'
import BackgroundCanvas from './background-canvas'
import { getNearestRowIndex, getCurrentRowIndex} from './selectors'

const mapStateToProps = state => {
  return {
    colourIndex: getNearestRowIndex(state),
    currentIndex: getCurrentRowIndex(state)
  }
}

export default connect(mapStateToProps, null)(BackgroundCanvas)



// WEBPACK FOOTER //
// ./src/components/background-canvas/index.js